import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@api/base-services-axios-rtx";

import getFormData from "@/shared/helpers/get-form-data.helper";
import { IAgenciesPublicResponse } from "@/shared/models/interfaces/response/agencies/public/agencies-list.response";
import { MortgageEndpoints } from "@/shared/models/endpoints/morgage.endpoint";

import { T_create_mortgage } from "./model/create/payload";
import { IMortgageList } from "@/shared/models/interfaces/response/morgage/morgage-list.response";
import { MortgageListValuesQRTK } from "./values/mortgage-list.value";
import { createQuery } from "@/shared/helpers/create-query.helper";
import { MortgageDetailValuesQRTK } from "./values/mortgage-detail.value";
import { IMortgageDetails } from "@/shared/models/interfaces/response/morgage/mortgage-detail.response";
import { MortgageStatusValuesQRTK } from "./values/mortgage-update-status.value";

export const MortgageQueryServices = createApi({
  reducerPath: "Mortgage-services",
  baseQuery: axiosBaseQuery(),

  endpoints: builder => ({
    createMortgageReferal: builder.mutation({
      query: (values: { body: T_create_mortgage }) => ({
        url: MortgageEndpoints.Mortgage_referral_create,
        method: "POST",
        body: getFormData(values.body)
      }),
      transformResponse: (response: IAgenciesPublicResponse, meta, arg) =>
        response.data
    }),
    getListMortgageReferal: builder.mutation({
      query: (v: MortgageListValuesQRTK) => ({
        url: MortgageEndpoints.Mortgage_List + createQuery(v.query),
        method: "GET"
      }),
      transformResponse: (response: IMortgageList, meta, arg) => {
        return response;
      }
    }),
    /**
     * Obtiene el detalle del referimiento hipotecario.
     * Respuesta tipada como IMortgageDetails (incluye bloque `documents`).
     */
    getDetailsMortgageReferal: builder.mutation({
      query: (v: MortgageDetailValuesQRTK) => ({
        url: MortgageEndpoints.Mortgage_Detail(v.params?.id!),
        method: "GET"
      }),
      transformResponse: (response: IMortgageDetails, meta, arg) => {
        return response;
      }
    }),
    updateMortgageReferal: builder.mutation({
      query: (v: MortgageStatusValuesQRTK) => ({
        url:
          MortgageEndpoints.Mortgage_Update_Status(v.params?.id!) +
          createQuery(v.query),
        method: "POST",
        body: getFormData(v.body)
      }),
      transformResponse: (response: any) => {
        return response;
      }
    })
  })
});

export const {
  useCreateMortgageReferalMutation,
  useGetListMortgageReferalMutation,
  useGetDetailsMortgageReferalMutation,
  useUpdateMortgageReferalMutation
} = MortgageQueryServices;
